import { Button } from '@amzn/awsui-components-core';
import { ContentWorkflow, WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { getContentPath } from '../../common/ContentPaths';

interface Props {
  workflow: ContentWorkflow;
}

class EditingDraftButton extends React.Component<Props> {
  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
  }

  public render() {
    const { contentId, draftState, publicationState } = this.props.workflow;

    if (
      [
        WorkflowState.PUBLISHED,
        WorkflowState.FINALIZING,
        WorkflowState.FINALIZED,
        WorkflowState.DISTRIBUTED,
        WorkflowState.REVOKED,
        // @ts-expect-error TS2345 - strict migration
      ].includes(publicationState)
    ) {
      const editingLink = this.isContentInPublisherReview(draftState)
        ? getContentPath({ contentId, mode: 'draft', role: 'read-only' })
        : getContentPath({ contentId, mode: 'draft', role: 'author' });
      return <Button variant="icon" iconName="edit" ariaLabel="Edit content" href={editingLink} />;
    } else {
      return null;
    }
  }

  private isContentInPublisherReview = (state: WorkflowState) => {
    return [WorkflowState.REVIEWED].includes(state);
  };
}

export default EditingDraftButton;
